var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticStyle:{"padding-top":"50px","text-align":"center","width":"100%"}},[_c('v-img',{staticStyle:{"margin":"0 auto"},attrs:{"src":_vm.image,"width":"213","height":"187"}}),_c('br'),_c('div',{staticClass:"pa-2 pt-6",staticStyle:{"margin":"auto"}},[_vm._v(" 잘못된 접근입니다. ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }